export const FLEXI_CANCELLATION_SHIELD_SVG_URL =
	'https://cdn-imgix.headout.com/assets/svg/flexi-cancellation/flexi-cancellation-shield.svg';
